import { selector } from './selector';
import { crud } from '../../../app/crud';

const URL_TRANSFER = '/customer/balance/transfer/';

function messages() {
    return (window.translations && window.translations.messages) || {};
}

// "12.450,50" -> 12450.5
function toFloat(value) {
    if (value === null || value === undefined) {
        return 0;
    }

    return parseFloat(String(value).replace(/\s/g, '').replace(/\./g, '').replace(',', '.')) || 0;
}

// 12450 -> "12.450,00"
function formatAmount(value) {
    var parts = value.toFixed(2).split('.');

    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
}

function currentBalance() {
    return toFloat($(selector.balanceAmount).first().text());
}

function minAmount() {
    return toFloat($(selector.transferAmount).data('min')) || 100;
}

function showMessage(type, text) {
    $(selector.transferMessage)
        .removeClass('alert-success alert-danger')
        .addClass(type === 'success' ? 'alert-success' : 'alert-danger')
        .text(text)
        .show();
}

function hideMessage() {
    $(selector.transferMessage).hide().text('');
}

// Posle prenosa osvezavamo iznos na kartici, u tabeli i u opciji selecta.
function applyNewBalances(response) {
    $(selector.balanceAmount).text(response.balance);

    if (!response.tagBalance) {
        return;
    }

    var serial = response.tagSerialNumber;

    $(selector.tagBalance + '[data-serial="' + serial + '"]').text(response.tagBalance + ' RSD');

    var $option = $(selector.transferTag).find('option[value="' + serial + '"]');
    $option.text($option.text().replace(/\(.*\)$/, '(' + response.tagBalance + ' RSD)'));
}

const openTransfer = function () {
    hideMessage();
    $(selector.transferAmount).val('');
};

const transferAll = function () {
    $(selector.transferAmount).val(formatAmount(currentBalance()));
};

const submitTransfer = function (e) {
    e.preventDefault();

    var m = messages();
    var serialNumber = $(selector.transferTag).val();
    var rawAmount = $(selector.transferAmount).val();
    var amount = toFloat(rawAmount);
    var balance = currentBalance();
    var min = minAmount();

    hideMessage();

    if (!serialNumber) {
        showMessage('error', m.balance_transfer_unknown_tag || '');
        return;
    }

    if (amount < min) {
        showMessage('error', (m.balance_transfer_min || '').replace(':amount', formatAmount(min)));
        return;
    }

    if (amount > balance) {
        showMessage('error', m.balance_transfer_insufficient || '');
        return;
    }

    var data = new FormData();
    data.append('amount', rawAmount);

    var $submit = $(selector.transferSubmit).prop('disabled', true);

    crud.create(URL_TRANSFER + encodeURIComponent(serialNumber), data)
        .done(function (response) {
            applyNewBalances(response);
            showMessage('success', response.message);
            $(selector.transferAmount).val('');
        })
        .fail(function (xhr) {
            showMessage('error', (xhr.responseJSON && xhr.responseJSON.message) || m.balance_transfer_error || '');
        })
        .always(function () {
            $submit.prop('disabled', false);
        });
};

export { openTransfer, transferAll, submitTransfer };
